<template>
  <div class="content-wrap">
    <div v-if="$slots.heading" class="content-wrap__heading">
      <slot name="heading" />
    </div>

    <h1 v-if="!$slots.heading && heading" class="text-3xl font-bold mb-6 pl-2 md:pl-0">{{ heading }}</h1>

    <div class="content-box">
      <div v-if="$slots.top" class="content-box__top md:rounded-t-md">
        <slot name="top" />
      </div>

      <div class="content-box__main bg-white px-4 py-3 md:px-8 md:py-6"
           :class="{'md:rounded-t-md': !$slots.top, 'md:rounded-b-md': !$slots.bottom}">
        <slot />
      </div>

      <div v-if="$slots.bottom" class="content-box__bottom md:rounded-b-md">
        <slot name="bottom" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentWrap',
  props: {
    heading: String
  }
}
</script>

<style scoped>
.content-box {
  &__top,
  &__bottom {
    background: #f7f9fd;
    padding: 20px 30px;

    .citizen-m & {
      background: #fff;
      padding-left: 0;
      padding-right: 0;
    }

    :deep(.el-form) {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;

      .el-form-item__label {
        display: block;
        text-align: left;
        font-size: 16px;
      }

      .el-form-item {
        margin-bottom: 0;
        margin-right: 30px !important;
      }
    }
  }

  .citizen-m & {
    padding-left: 5px;
    padding-right: 5px;

    &__main {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
